// src/pages/NotFoundPage.jsx
// 404 page
// Added: Google Analytics tracking

import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { trackPageView, trackPageNotFound } from "../utils/analytics";
import "../styles/AdminDashboard.css"; // reuse admin styles for header/background

export default function NotFoundPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Track 404 on mount
  useEffect(() => {
    trackPageView('/404', 'Page Not Found');
    trackPageNotFound(location.pathname);
  }, [location.pathname]);

  return (
    <div className="admin-root">
      <header className="admin-header">
        <div className="admin-header-inner">
          <div className="brand">
            <span className="brand-main">Invenire</span>
            <span className="brand-sep">|</span>
            <span className="brand-sub">Interview</span>
          </div>
          <button
            className="btn-sub"
            type="button"
            onClick={() => navigate("/")}
          >
            Go Home
          </button>
        </div>
      </header>

      <main className="admin-main">
        <section className="admin-hero">
          <div className="admin-hero-text">
            <h1>Page Not Found</h1>
            <p>
              The page you requested could not be found. Please check the link
              and try again. If you believe this is an error, you can return
              to the main site or contact your recruiter for a fresh link.
            </p>
          </div>
        </section>

        <section className="admin-grid">
          <div className="admin-card">
            <h2>What you can do next</h2>
            <ul style={{ paddingLeft: 18, marginTop: 8 }}>
              <li>Verify that the URL was copied completely.</li>
              <li>Ensure there are no extra characters or spaces.</li>
              <li>
                If you followed an interview link from an email, try clicking
                it again.
              </li>
            </ul>
            <button
              className="btn"
              style={{ marginTop: 16 }}
              type="button"
              onClick={() => navigate("/")}
            >
              Go to Home
            </button>
          </div>
        </section>
      </main>
    </div>
  );
}
